module.exports = __webpack_public_path__ + "static/img/homecenter.ff0ea2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images/homecenter.png
// module id = ewND
// module chunks = 44